export const videoJson = {
  powerplay : {
    name         : 'Power Play',
    src          : './assets/videos/powerpay2026.mp4',
    back_button  : 'home'
  },
  /*
  energy1 : {
    name         : 'Cost & Usage Trends',
    src          : './assets/videos/energyAdvisor/video1.mp4',
    back_button  : 'commercial'
  },
  energy2 : {
    name         : 'Bill Summary',
    src          : './assets/videos/energyAdvisor/vidoe2.mp4',
    back_button  : 'commercial'
  },
  energy3 : {
    name         : 'Ways to Save',
    src          : './assets/videos/energyAdvisor/video3.mp4',
    back_button  : 'commercial'
  },
  energy4 : {
    name         : 'Operation Schedule',
    src          : './assets/videos/energyAdvisor/video4.mp4',
    back_button  : 'commercial'
  },
  */
  energy5 : {
    name         : 'Energy Management Tools',
    src          : './assets/videos/energytools/video.mp4',
    back_button  : 'residential'
  },
  get1 : {
    name         : 'Get to Know PSO',
    src          : './assets/videos/gettoknow/video1.mp4',
    back_button  : 'gettoknow'
  },
  get2 : {
    name         : 'About PSO',
    src          : './assets/videos/gettoknow/video2.mp4',
    back_button  : 'gettoknow'
  },
  renew1 : {
    name         : 'Get to Know Electric Vehicles',
    src          : './assets/videos/renew/video1.mp4',
    back_button  : 'renew'
  },
  renew2 : {
    name         : 'Do you have questions about electric vehicles?',
    src          : './assets/videos/renew/video2.mp4',
    back_button  : 'renew'
  },
  /*
  renew3 : {
    name         : 'Get to know rebates',
    src          : './assets/videos/renew/video3.mp4',
    back_button  : 'renew'
  },
  */
  hours1 : {
    name         : 'Power Hours Couple',
    src          : './assets/videos/hours/video1.mp4',
    back_button  : 'powerhours'
  },
  hours2 : {
    name         : 'Family At The Waterpark',
    src          : './assets/videos/hours/video2.mp4',
    back_button  : 'powerhours'
  },
  forward1 : {
    name : 'LED Bulbs',
    src   : './assets/videos/forward/video1.mp4',
    back_button : 'powerforward'
  },
  forward2 : {
    name : 'Insulation',
    src   : './assets/videos/forward/video2.mp4',
    back_button : 'powerforward'
  },
  forward3 : {
    name : 'Energy Efficiency',
    src   : './assets/videos/forward/video3.mp4',
    back_button : 'powerforward'
  },
  forward4 : {
    name : 'Watts & Lumens',
    src   : './assets/videos/forward/video4.mp4',
    back_button : 'powerforward'
  },
  forward5 : {
    name : 'Find the right fixture bulbs',
    src   : './assets/videos/forward/video5.mp4',
    back_button : 'powerforward'
  },
  forward6 : {
    name : 'Business Rebates',
    src   : './assets/videos/forward/video6.mp4',
    back_button : 'powerforward'
  },
  forward7 : {
    name : 'Lighting And Refrigeration',
    src   : './assets/videos/forward/video7.mp4',
    back_button : 'powerforward'
  },
  forward8 : {
    name : 'New Home Build BluePrint',
    src   : './assets/videos/forward/video8.mp4',
    back_button : 'powerforward'
  },
  forward9 : {
    name : 'Light Appearance',
    src   : './assets/videos/forward/video9.mp4',
    back_button : 'powerforward'
  },
  forward10 : {
    name : 'Energy Star Bulbs',
    src   : './assets/videos/forward/video10.mp4',
    back_button : 'powerforward'
  },
  forward11 : {
    name : 'Shopping For Supplies To Spurce Up Your Pad',
    src   : './assets/videos/forward/video11.mp4',
    back_button : 'powerforward'
  },
  forward12 : {
    name : 'Shopping for Air Conditioner',
    src   : './assets/videos/forward/video12.mp4',
    back_button : 'powerforward'
  },
  forward13 : {
    name : 'Peak Performers',
    src   : './assets/videos/forward/video13.mp4',
    back_button : 'powerforward'
  },
  forward14 : {
    name : 'Small Business Video',
    src   : './assets/videos/forward/video7.mp4',
    back_button : 'powerforward'
  },
  forward15 : {
    name : 'General Rebates',
    src   : './assets/videos/forward/video15.mp4',
    back_button : 'powerforward'
  },
  forward16 : {
    name : 'New Build Blueprint',
    src   : './assets/videos/forward/video16.mp4',
    back_button : 'powerforward'
  },
  forward17 : {
    name : 'Live Life Forward',
    src   : './assets/videos/renew/video3.mp4',
    back_button : 'powerforward'
  },
  billhelp : {
    name : 'PSO Bill Analyzer',
    src   : './assets/videos/sept2026.mp4',
    back_button : 'powerforward'
  },
}